module.exports = __webpack_public_path__ + "img/pagamento_online.11591bae.svg";